const EXPIRES_PARAM_RE = /[?&]Expires=([^&#]*)/;
const SIGNATURE_PARAM_RE = /^(?:Expires|Signature|Key-Pair-Id|Policy)=/;

/**
 * CloudFront presigned file URLs include an `Expires` query param (Unix seconds).
 * String scans, not `new URL`: these run per link over every row on a canvas.
 */
export function getPresignedUrlExpiresAtMs(
  url: string | undefined,
): number | null {
  if (!url) return null;
  const expires = EXPIRES_PARAM_RE.exec(url)?.[1];
  if (!expires) return null;
  const seconds = Number.parseInt(expires, 10);
  if (!Number.isFinite(seconds) || seconds <= 0) return null;
  return seconds * 1000;
}

/** The address without its CloudFront signature: same bytes, same key. */
export function presignedResourceKey(url: string | undefined): string | null {
  if (!url) return null;
  const hashAt = url.indexOf("#");
  const address = hashAt === -1 ? url : url.slice(0, hashAt);
  const queryAt = address.indexOf("?");
  if (queryAt === -1) return address;
  const params = address
    .slice(queryAt + 1)
    .split("&")
    .filter((param) => !SIGNATURE_PARAM_RE.test(param));
  const base = address.slice(0, queryAt);
  return params.length === 0 ? base : `${base}?${params.join("&")}`;
}
